import http from '../utils/http';
import { interpolate } from 'utils/string';
import { HOLIDAYS, HOLIDAY_URL_ID } from '../constants/endpoints';
import type { Holiday } from 'interface/holiday';
import type { ServiceId, ServiceParams } from 'interface/service';

export async function fetch(params: ServiceParams) {
  return await http.get(HOLIDAYS, { params });
}

export async function create(holiday: Holiday) {
  return await http.post(HOLIDAYS, { body: holiday });
}

export async function update(id: ServiceId, holiday: Holiday) {
  return await http.put(interpolate(HOLIDAY_URL_ID, { id }), { body: holiday });
}

export async function fetchById(id: ServiceId) {
  return await http.get(interpolate(HOLIDAY_URL_ID, { id }));
}

export async function remove(id: ServiceId) {
  return await http.delete(interpolate(HOLIDAY_URL_ID, { id }));
}
